import { TableRow } from '@mui/material'

import { HeaderColumnCells } from './HeaderColumnCells'
import { HorizontalHeaderRow } from './HorizontalHeaderRow'
import { RowData, RowsProps } from './types'
import { productFruitsSelector } from './utils'
import { ValueColumnCells } from './ValueColumnCells'

export const Rows = ({ data, sx, variant }: RowsProps): React.JSX.Element => {
  const verticalHeaderLength: number = Math.max(
    ...data.rows.map((row: RowData): number => row.verticalHeaders.length),
  )

  return (
    <>
      <HorizontalHeaderRow
        data={data}
        sx={sx}
        verticalHeaderLength={verticalHeaderLength}
      />

      {data.rows.map(
        ({ basePrefix, variants, verticalHeaders }, index): React.JSX.Element => (
          <TableRow
            data-product-fruits={variant === 'add' ? productFruitsSelector(basePrefix) : undefined}
            id={`variants-table-row-${index}`}
            key={index}
          >
            <HeaderColumnCells
              basePrefix={basePrefix}
              sx={sx}
              verticalHeaderLength={verticalHeaderLength}
              verticalHeaders={verticalHeaders}
            />
            <ValueColumnCells
              key={index}
              variants={variants}
            />
          </TableRow>
        ),
      )}
    </>
  )
}
